import SmazzoStesa from "./SmazzoStesa";

// I Tarocchi usano dritto + rovescio: stessa fisica reale del caos
// di Vera Sibilla e Piacentine (stessa infrastruttura, mazzo reale).
// La scelta del mazzo (Maggiori 22 / Minori 56 / completo 78) avviene in SmazzoStesa.
export default function Tarocchi() {
  return <SmazzoStesa deck="tarocchi" />;
}
